// extracted by mini-css-extract-plugin
export default {"tabs":"tabs--doqs0","pageHeading":"pageHeading--doqs0","pageDescription":"pageDescription--doqs0","breadcrumb":"breadcrumb--doqs0"};